// extracted by mini-css-extract-plugin
module.exports = {"listItem":"CreateNewGoalWidget--styles-module_listItem-29Vr6","icon":"CreateNewGoalWidget--styles-module_icon-iVVk6"};